import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["placeholder"];
const _hoisted_3 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_6 = {
    key: 1,
    class: "error form-group__message"
};
const _hoisted_7 = ["placeholder"];
const _hoisted_8 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_9 = {
    key: 1,
    class: "error form-group__message"
};
const _hoisted_10 = ["placeholder"];
const _hoisted_11 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_12 = { class: "form-group" };
const _hoisted_13 = ["placeholder"];
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = ["placeholder"];
const _hoisted_16 = { class: "modal-footer" };
const _hoisted_17 = ["disabled"];
const _hoisted_18 = {
    key: 1,
    class: "terms-frame-container"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
    key: 2,
    class: "text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["BModal"], {
        ref: "registerAccountDialog",
        centered: "",
        "no-footer": "",
        "dialog-class": "create-account",
        size: "lg",
        title: _ctx.$t('JTADM_USERS_REGISTER')
    }, {
        default: _withCtx(() => [
            ($setup.termsAccepted && !$setup.created)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["form-group", { 'form-group--error': $setup.v$.user.name.$error }])
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            id: "inputName",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.user.name) = $event)),
                            type: "text",
                            placeholder: _ctx.$t('JTADM_NAME'),
                            onInput: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => ($setup.v$.user.name.$touch && $setup.v$.user.name.$touch(...args)))
                        }, null, 40, _hoisted_2), [
                            [_vModelText, $setup.user.name]
                        ]),
                        ($setup.v$.user.name.$error && $setup.v$.user.name.required.$invalid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('JTADM_VALIDATION_REQUIRED_NAME')), 1))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["form-group", { 'form-group--error': $setup.v$.user.email.$error }])
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            id: "inputEmail",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.user.email) = $event)),
                            type: "text",
                            placeholder: _ctx.$t('JTADM_EMAIL'),
                            onInput: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => ($setup.v$.user.email.$touch && $setup.v$.user.email.$touch(...args)))
                        }, null, 40, _hoisted_4), [
                            [_vModelText, $setup.user.email]
                        ]),
                        ($setup.v$.user.email.$error && $setup.v$.user.email.required.$invalid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('JTADM_VALIDATION_REQUIRED_EMAIL')), 1))
                            : ($setup.v$.user.email.$error && $setup.v$.user.email.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('JTADM_INVALID_EMAIL_ADDRESS')), 1))
                                : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["form-group", { 'form-group--error': $setup.v$.user.password.$error }])
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            id: "inputPassword",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($setup.user.password) = $event)),
                            type: "password",
                            placeholder: _ctx.$t('JTADM_PASSWORD'),
                            onInput: _cache[5] || (_cache[5] =
                                //@ts-ignore
                                (...args) => ($setup.v$.user.password.$touch && $setup.v$.user.password.$touch(...args)))
                        }, null, 40, _hoisted_7), [
                            [_vModelText, $setup.user.password]
                        ]),
                        ($setup.v$.user.password.$error && $setup.v$.user.password.required.$invalid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('JTADM_VALIDATION_REQUIRED_PASSWORD')), 1))
                            : ($setup.v$.user.password.$error && $setup.v$.user.password.minLength.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('JTADM_VALIDATION_MIN_LENGTH_PASSWORD', { minLength: $setup.v$.user.password.minLength.$params.min })), 1))
                                : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["form-group", { 'form-group--error': $setup.v$.user.password_confirmation.$error && (!!$setup.user.password_confirmation || !!$setup.user.password) }])
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            id: "inputpassword_confirmation",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (($setup.user.password_confirmation) = $event)),
                            type: "password",
                            placeholder: _ctx.$t('JTADM_REPEAT_PASSWORD'),
                            onInput: _cache[7] || (_cache[7] =
                                //@ts-ignore
                                (...args) => ($setup.v$.user.password_confirmation.$touch && $setup.v$.user.password_confirmation.$touch(...args)))
                        }, null, 40, _hoisted_10), [
                            [_vModelText, $setup.user.password_confirmation]
                        ]),
                        ($setup.v$.user.password_confirmation.$dirty && $setup.user.password !== $setup.user.password_confirmation)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('JTADM_VALIDATION_SAME_AS_PASSWORD')), 1))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            id: "input_organization",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (($setup.user.organization) = $event)),
                            type: "text",
                            placeholder: _ctx.$t('JTADM_ORGANIZATION')
                        }, null, 8, _hoisted_13), [
                            [_vModelText, $setup.user.organization]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            id: "input_position",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (($setup.user.position) = $event)),
                            type: "text",
                            placeholder: _ctx.$t('JTADM_POSITION')
                        }, null, 8, _hoisted_15), [
                            [_vModelText, $setup.user.position]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                            class: "btn btn-info text-white",
                            type: "submit",
                            disabled: $setup.v$.$invalid,
                            onClick: _withModifiers($setup.createUser, ["prevent"])
                        }, _toDisplayString(_ctx.$t('JTADM_USERS_CREATE')), 9, _hoisted_17),
                        _createElementVNode("button", {
                            class: "btn btn-danger",
                            type: "button",
                            onClick: _cache[10] || (_cache[10] = ($event) => ($setup.registerAccountDialog?.hide()))
                        }, _toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                    ])
                ]))
                : (!$setup.created && !$setup.termsAccepted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("iframe", {
                            class: "terms-frame",
                            src: $setup.terms
                        }, null, 8, _hoisted_19),
                        _createElementVNode("button", {
                            class: "btn btn-md btn-primary btn-block mt-1",
                            onClick: _cache[11] || (_cache[11] = _withModifiers(($event) => ($setup.termsAccepted = true), ["prevent"]))
                        }, _toDisplayString(_ctx.$t('JTADM_USERS_ACCEPT')), 1)
                    ]))
                    : _createCommentVNode("", true),
            ($setup.created)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t('JTADM_USERS_CREATE_NOTICE', { email: $setup.user.email })), 1),
                    _cache[13] || (_cache[13] = _createElementVNode("p", null, "Join Triage Application", -1)),
                    _createElementVNode("button", {
                        class: "btn btn-lg btn-primary",
                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event) => ($setup.registerAccountDialog?.hide()), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('JTADM_CLOSE')), 1)
                ]))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 8, ["title"]));
}
